import {camelCase, pascalCase} from 'change-case'
import store from '../store'
import {DateTime} from '../utils/dateHelpers'

const debug = false

const validateFilterValue = (filterColumn, filterValue) => {
  // -- make sure we have a column, a legit value, and also the column has a defined 'type'
  // // console.log('validateFilterValue', filterColumn, filterValue)
  return !(!filterColumn || filterValue === undefined || filterValue === null || !filterColumn.type || filterValue === '')
}

const convertFilter = (filterKeyRaw, filterValue, filterColumn, titleCaseFilterKey = null, type = null) => {
  // console.log('convertFilter filterColumn', filterColumn)
  if (debug) {
    console.log('convertFilter: filterKeyRaw', filterKeyRaw, 'filterValue', filterValue, 'filterColumn', filterColumn, 'titleCaseFilterKey', titleCaseFilterKey, 'type', type)
  }

  /** ------------ Safety Check -------------------------- **/
  if (!validateFilterValue(filterColumn, filterValue)) {
    return null
    // -- end --
  }

  const filterKey = filterKeyRaw
  // let filterKey = camelCase(filterKeyRaw)
  // if (filterColumn.type === 'many') {
  //   filterKey = filterKeyRaw
  // }

  // -- setup key
  let key = titleCaseFilterKey ? `${titleCaseFilterKey}/${filterKey}` : filterKey
  if (filterColumn.relation && filterColumn.relation.directSearch) {
    // Manual override for complex relation filters
    // console.log('filterColumn.relation.directSearch', filterColumn.relation.directSearch)
    key = filterColumn.relation.directSearch
  }

  // console.log('convertFilter filterColumn', filterColumn)

  /** ------------ Handle filterIs Custom -------------------------- **/
  if (filterColumn && filterColumn.component && filterColumn.component.filterIs && filterColumn.component.filterCustom && filterValue) {
    return `${key} ${filterValue}`
  }

  /** ------------ Handle Date -------------------------- **/
  if (
    filterValue &&
    filterColumn &&
    filterColumn.type &&
    (filterColumn.type === 'date' || filterColumn.type === 'datetime' || filterColumn.searchType === 'datetime' || (filterColumn.relation && (filterColumn.relation.fieldType === 'date' || filterColumn.relation.fieldType === 'datetime')))
  ) {
    let startDate = DateTime(filterValue)
      .subtract(1, 'day')
      .format()
    let endDate = DateTime(filterValue)
      .add(1, 'day')
      .format()
    if (filterColumn && filterColumn.relation && filterColumn.relation.linkTable) {
      return `${key} ge ${startDate}) AND ${key} le ${endDate})`
    }
    return `${key} ge ${startDate} AND ${key} le ${endDate}`
  }

  /** ------------ Handle Many Relation -------------------------- **/
  if (type === 'many') {
    // console.log('got many')
    // console.log('key', key)
    return `${key} eq ${filterValue}`
    // -- end --
  }

  /** ------------ Handle Boolean -------------------------- **/
  if (filterColumn.type === 'boolean' || filterColumn.searchType === 'boolean' || (filterColumn.relation && filterColumn.relation.fieldType === 'boolean')) {
    // console.log('got bool')
    const booleanValue = filterValue ? 'true' : 'false'
    return `${key} eq ${booleanValue}`
    // -- end --
  }

  /** ------------ Handle Number -------------------------- **/
  if (filterColumn.type === 'number' || filterColumn.searchType === 'number' || (filterColumn.relation && filterColumn.relation.fieldType === 'number')) {
    // console.log('got number')
    return `${key} eq ${filterValue}`
    // -- end --
  }

  /** ------------ Handle NotNull -------------------------- **/
  if (filterColumn.type === 'notNull' || filterColumn.searchType === 'notNull' || (filterColumn.relation && filterColumn.relation.fieldType === 'notNull')) {
    // console.log('got notNull')
    return `${filterValue} ne null`
    // -- end --
  }

  /** ------------ Handle String -------------------------- **/
  if (filterColumn.type === 'string' || filterColumn.searchType === 'string' || (filterColumn.relation && filterColumn.relation.fieldType === 'string')) {
    // console.log('got string')
    const filterReplace = filterValue.replace("'", "''")
    return `contains(${key},'${filterReplace}')`
    // -- end --
  }

  return null
  // -- end --
}

const isObject = value => {
  return !!value && typeof value === 'object' && !!Object.keys(value).length
}

export const oDataHelper = includes => {
  // -- validate data
  // console.log('includes', includes)
  if (typeof includes !== 'string' || includes === null || includes === undefined) {
    return ''
  }
  // -- replace '[]' with '()'
  const re = /(.*)(\[)(.*)(])/
  return includes
    .split(',')
    .map(include => {
      if (include.indexOf('[') !== -1) {
        // Replace brackets with parenthesis? Not sure why, I think oData supports both?
        return include.trim().replace(re, (str, p1, p2, p3) => {
          const p1Title = pascalCase(p1)
          const p3Title = pascalCase(p3)
          // console.log(p1, p1Title)
          // console.log(p3, p3Title)
          // const nv = p1Title + '(' + p3Title + ')'
          const nv = p1Title + '[$expand=' + p3Title + ']'
          // console.log(nv)
          return nv
        })
      }
      if (include.indexOf('.') !== -1) {
        // We want to check for dot syntax here for includes and add another layer of expand within an expand
        // TODO: probably need to come back to this to check for recursive functionality
        const expandSplit = include.split('.')
        return expandSplit.reduce((query, includeText, currentIndex) => {
          if (currentIndex === 0) {
            query = query + pascalCase(includeText)
          } else {
            query = query + `[$expand=${pascalCase(includeText)}]`
          }
          return query
        }, '')
      }
      return pascalCase(include)
    })
    .join(',')
}

export const oDataSort = (sortBy, namespace, fakeColumns) => {
  // In Odata we can sort on one to many relations
  let sort = sortBy
  // console.log('sortBy', sortBy, 'namespace', namespace, 'fakeColumns', fakeColumns)
  // fakeColumns.membershipType = membership
  // sortBy = membershipType
  if (sortBy) {
    const sortColumn = store.getters[`${namespace}/column`](sortBy)
    // console.log('sortColumn', sortColumn)
    if (sortColumn && sortColumn.relation && sortColumn.relation.type === 'one' && sortColumn.relation.label) {
      // sortColumn.relation.label = description
      let finalSortBy = false
      if (sortColumn.relation.orderBy) {
        // Allow overrides on sorting for columns that reference more than just a signle field, but a table!
        // console.log('sortColumn.relation.orderBy', sortColumn.relation.orderBy)
        finalSortBy = sortColumn.relation.orderBy
      }
      if (fakeColumns && fakeColumns[sortBy]) {
        // console.log('found fake columns to sort on')
        if (sortBy === sortColumn.relation.label) {
          if (finalSortBy) {
            sort = `${fakeColumns[sortBy]}/${finalSortBy}`
          } else {
            sort = `${fakeColumns[sortBy]}/${sortBy}`
          }
        } else {
          if (finalSortBy) {
            sort = `${fakeColumns[sortBy]}/${sortBy}/${finalSortBy}`
          } else {
            sort = `${fakeColumns[sortBy]}/${sortBy}/${sortColumn.relation.label}`
          }
        }
      } else {
        if (finalSortBy) {
          sort = `${sortBy}/${finalSortBy}`
        } else {
          sort = `${sortBy}/${sortColumn.relation.label}`
        }
      }
      // console.log('SORT:', sort)
    }
  }
  return sort
  // EXAMPLE: affiliateType/name desc
  // go another level deep! membership/membershipType/description asc
}

export const oDataFilter = (filterObj = {}, moduleName, fakeColumnsMap = {}) => {
  return Object.keys(filterObj)
    .reduce((arr, rawFilterKey) => {
      /**
       * @var Boolean|Object|Number|String filterValue
       * @description User entered value if not a relation
       * @example [Boolean] 1|0
       * @example [Number] 2005
       * @example [String] 'David'
       * @example [Relation] { membershipType: Affiliate }
       */
      const filterKey = camelCase(rawFilterKey)
      const filterValue = filterObj[filterKey]
      const filterColumn = store.getters[`${moduleName}/column`](filterKey)

      if (debug) {
        console.log('filterObj', filterObj)
        console.log('filterKey / camelCase(rawFilterKey): ', filterKey)
        console.log('filterValue: ', filterValue)
        console.log('filterColumn: ', filterColumn)
        console.log('fakeColumnsMap: ', fakeColumnsMap)
      }

      /** ------------ Safety Check -------------------------- **/
      if (!validateFilterValue(filterColumn, filterValue)) {
        if (debug) {
          console.log('------ invalid filter -------')
        }
        return arr
        // -- end --
      }

      /** ------------ Handle Fake Columns -------------------------- **/
      if (fakeColumnsMap && fakeColumnsMap[rawFilterKey]) {
        // console.log('fakeColumnsMap', fakeColumnsMap)
        if (filterValue && filterValue !== null && filterValue !== undefined) {
          // -- loop each key in the relation (probably only one)
          // const relationKey = `any(a:a/${relationColumn.field}`
          if (Array.isArray(filterValue)) {
            console.log('is array')
            // const relationKey = `any(a:a/${filterColumn}`
            for (const fv of filterValue) {
              const relationValue = fv.id
              const titleCaseFilterKey = pascalCase(filterKey)
              const convertedRelationValue = convertFilter(filterColumn, relationValue, filterColumn, titleCaseFilterKey, 'many') + ')'
              // const convertedRelationValue = convertFilter(relationKey, relationValue, relationColumn, titleCaseFilterKey, 'many') + ')'
              if (convertedRelationValue) {
                arr.push(convertedRelationValue)
              }
            }
          } else {
            console.log('not array')
            const realFilterKey = fakeColumnsMap[rawFilterKey]
            // console.log('realFilterKey', realFilterKey)
            const fakeFilterValues = Object.values(filterValue)
            // console.log('fakeFilterValues', fakeFilterValues)
            if (fakeFilterValues.length) {
              const fakeFilterValue = fakeFilterValues[0]
              const titleCaseFilterKey = pascalCase(realFilterKey)
              const convertedValue = convertFilter(filterKey, fakeFilterValue, filterColumn, titleCaseFilterKey)
              // console.log('titleCaseFilterKey', titleCaseFilterKey)
              // console.log('convertedValue', convertedValue)
              if (convertedValue) {
                arr.push(convertedValue)
              }
            }
          }
          return arr
        }
      }

      // // console.log('filterColumn', filterColumn)
      // // console.log('filterValue', filterValue)
      // // console.log('data type', typeof filterValue, filterValue, 'date:', filterValue instanceof Date, normalizeDate(filterValue))

      // /** ------------ Handle Date Filter -------------------------- **/
      // if (filterValue && filterColumn && filterColumn.type && (filterColumn.type === 'date' || filterColumn.type === 'datetime')) {
      //   let startDate = DateTime(filterValue)
      //     .subtract(1, 'day')
      //     .format()
      //   let endDate = DateTime(filterValue)
      //     .add(1, 'day')
      //     .format()
      //   // // console.log('we have a date!!')
      //   arr.push([`${filterColumn.field} ge ${startDate}`, `${filterColumn.field} le ${endDate}`])
      //   console.log('push date', arr)
      //   return arr
      // }

      /** ------------ Handle Relation One -------------------------- **/
      if (filterColumn.relation && filterColumn.relation.type === 'one' && filterColumn.relation.namespace) {
        // console.log('odata relation one')
        // -- object: this should always be the case!
        if (typeof filterValue === 'object') {
          const module = filterColumn.relation.namespace
          const relationKeys = Object.keys(filterValue)

          // console.log('typeof filterValue is object', filterValue)
          // console.log('module', module)
          // console.log('relationKeys', relationKeys)

          // -- loop each key in the relation (probably only one)
          for (const relationKey of relationKeys) {
            // -- use the store module getters helper to get the column object from the filterKey name (field)
            // const relationColumn = store.getters[`${module}/column`](filterKey)
            const relationColumn = store.getters[`${module}/column`](relationKey)
            // const relationValue = filterValue[filterKey]
            const relationValue = filterValue[relationKey]
            const titleCaseFilterKey = pascalCase(filterKey)
            if (filterColumn.relation.searchColumns) {
              const mutlipleCols = filterColumn.relation.searchColumns
                .reduce((innerArr, searchColumn) => {
                  // console.log('relationColumn', relationColumn, 'relationValue', relationValue, 'titleCaseFilterKey', titleCaseFilterKey)
                  let convertedValue = convertFilter(searchColumn, relationValue, relationColumn, titleCaseFilterKey)
                  if (convertedValue) {
                    // console.log('innerArr', innerArr, 'convertedValue', convertedValue)
                    innerArr.push(convertedValue)
                  }
                  return innerArr
                }, [])
                .join(' or ')
              if (mutlipleCols) {
                // console.log('mutlipleCols', mutlipleCols)
                arr.push(mutlipleCols)
              }
            } else {
              const convertedRelationValue = convertFilter(relationKey, relationValue, relationColumn, titleCaseFilterKey)
              // console.log('relationColumn', relationColumn, 'relationValue', relationValue, 'titleCaseFilterKey', convertedRelationValue)
              if (convertedRelationValue) {
                arr.push(convertedRelationValue)
              }
            }
          }
        }
        // console.log('arr', arr)
        return arr
        // -- end --
      }

      /** ------------ Handle Relation Many -------------------------- **/
      if (filterColumn.relation && filterColumn.relation.type === 'many' && filterColumn.relation.namespace) {
        // console.log('odata relation many')
        // -- object: this should always be the case!
        if (typeof filterValue === 'object') {
          const module = filterColumn.relation.namespace
          // const relationKeys = Object.keys(filterValue)

          // console.log('typeof filterValue is object', filterValue)
          // console.log('module', module)
          // console.log('relationKeys', relationKeys)

          // TODO: need the filterKey module?
          // TODO: fk from column filterKey module = namespace
          const relationResource = store.getters[`${filterKey}/relations`]
          let relationColumn = null
          for (const column of relationResource) {
            // console.log(column)
            if (column.relation.namespace === module) {
              relationColumn = column
            }
          }
          const relationKey = `any(a:a/${relationColumn.field}`
          // console.log('relationKey', relationKey)

          // -- loop each key in the relation (probably only one)
          for (const fv of filterValue) {
            // -- use the store module getters helper to get the column object from the filterKey name (field)

            // Gotta get relationKey = areaOfStateId
            const relationValue = fv.id
            const titleCaseFilterKey = pascalCase(filterKey)
            const convertedRelationValue = convertFilter(relationKey, relationValue, relationColumn, titleCaseFilterKey, 'many') + ')'
            // const convertFilter = (filterKeyRaw, filterValue, filterColumn, titleCaseFilterKey = null) => {
            // console.log('relationResource', relationResource, 'relationColumn', relationColumn, 'relationValue', relationValue, 'titleCaseFilterKey', titleCaseFilterKey)
            // console.log('convertedRelationValue', convertedRelationValue)
            if (convertedRelationValue) {
              arr.push(convertedRelationValue)
            }
          }
        }
        // console.log('arr', arr)
        return arr
        // -- end --
      }

      const convertedValue = convertFilter(filterKey, filterValue, filterColumn)

      if (convertedValue) {
        arr.push(convertedValue)
      }

      return arr
      // -- end --
    }, [])
    .join(' and ')
}

export const transformLinkTableObject = obj => {
  return Object.entries(obj).reduce(
    (carryObj, entry) => {
      const key = entry[0]
      const value = entry[1]
      if (isObject(value)) {
        for (const objKey of Object.keys(value)) {
          carryObj[objKey] = value[objKey]
        }
        return carryObj
      }
      if (Array.isArray(value)) {
        console.log('ffffffffs!!!! Im confused!')
      }
      carryObj.pivot[key] = value
      return carryObj
    },
    { pivot: {} }
  )
}

export const transformLinkTableArray = arr => {
  if (!Array.isArray(arr)) {
    console.warn('transformLinkTableArray received non-array input:', arr)
    return []
  }
  return arr.map(obj => transformLinkTableObject(obj))
}

export const normalizeRow = (row, columns, fakeColumns = {}) => {
  const newRow = Object.entries(row).reduce((carry, entry) => {
    const key = entry[0]
    const value = entry[1]
    const column = columns.find(col => col.field === key)
    if (column) {
      if (column.relation && column.relation.linkTable) {
        carry[key] = transformLinkTableArray(value)
        // // console.log(carry[key])
        return carry
      }
    }
    carry[key] = value
    return carry
  }, {})

  if (fakeColumns) {
    for (const fakeKey of Object.keys(fakeColumns)) {
      const realColumn = fakeColumns[fakeKey]
      newRow[fakeKey] = newRow[realColumn]
    }
  }

  return newRow
}

export const normalizeApiData = (data, columns, fakeColumns = {}) => {
  let arr = data.data
  let mapped = arr.map(row => normalizeRow(row, columns, fakeColumns))
  if (data && data.search_ids) {
    console.log('data.search_ids', data.search_ids)
    console.log('Pre Sort', mapped)
    mapped = mapOrder(data.data, data.search_ids, 'id')
    console.log('Sorted Array', mapped)
    // we want: 3788,103,2780,645,3847,2376,3569,683,550,1095
  }
  return mapped
}

// const validateFilterValue = (filterColumn, filterValue) => {
export const mapOrder = (array, order, key) => {
  // const orderArray = order.split(',')
  // const reversedOrder = orderArray.reverse()
  // const reversedOrderString = reversedOrder.join(',')
  // const reversedOrder = order
  console.log('order', order)
  // console.log('reversedOrder', reversedOrder)
  // console.log('reversedOrderString', reversedOrderString)
  array.sort((a, b) => {
    var A = a[key],
      B = b[key]
    if (order.indexOf(A) > order.indexOf(B)) {
      return 1
    } else {
      return -1
    }
  })

  return array
}
